"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/MFA/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _components = require('web/screens/Login/components');
var _CodeForm = require('./CodeForm'); var _CodeForm2 = _interopRequireDefault(_CodeForm);
var _PhoneForm = require('./PhoneForm'); var _PhoneForm2 = _interopRequireDefault(_PhoneForm);








const MFA = ({ challenge, longlived, onVerified, onBack }) => {
  const [maskedPhone, setMaskedPhone] = _react.useState.call(void 0, challenge.MaskedPhone)
  const [isEnrollmentRequired, setIsEnrollmentRequired] = _react.useState.call(void 0, challenge.EnrollmentRequired)

  const sendPhoneCode = (phone) =>
    _client2.default.sendLoginMFAPhoneCode(challenge.ChallengeKey, phone)
      .then(r => {
        setMaskedPhone(r.MaskedPhone)
        setIsEnrollmentRequired(false)
      })

  const verify = (code) =>
    _client2.default.verifyLoginMFA(challenge.ChallengeKey, code, longlived)
      .then(onVerified)

  const resend = () =>
    _client2.default.resendLoginMFACode(challenge.ChallengeKey)
      .then(r => { setMaskedPhone(r.MaskedPhone) })

  return isEnrollmentRequired
    ? (
        _react2.default.createElement(_components.FormWrapper, { title: "Add your mobile phone"   , onBack: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
          , _react2.default.createElement(_PhoneForm2.default, { onSubmit: sendPhoneCode, phonePolicy: challenge.PhonePolicy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} )
        )
      )
    : (
        _react2.default.createElement(_components.FormWrapper, { title: "Enter the 6-digit code"   , onBack: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
          , _react2.default.createElement(_CodeForm2.default, { maskedPhone: maskedPhone, onSubmit: verify, onResend: resend, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
        )
      )
}

exports. default = MFA
